function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1895",
  "data-name": "Group 1895",
  transform: "translate(23156 6452)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(-23156 -6452)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_245",
  "data-name": "Group 245",
  transform: "translate(-24214.383 -6879.384)"
}, /*#__PURE__*/React.createElement("g", {
  id: "scholarship",
  transform: "translate(1068.477 435.738)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M11.954,11.777a7.339,7.339,0,0,0-.121-.863,10.938,10.938,0,0,0-3.415-6.3.418.418,0,0,0-.266-.1c-1.418,0-2.837,0-4.255-.009a.558.558,0,0,0-.415.168A10.988,10.988,0,0,0,.021,11.68a2.3,2.3,0,0,0,1.041,2.333,2.938,2.938,0,0,0,1.444.454c1.16.064,2.32.1,3.4.151.942-.03,1.8-.052,2.66-.089a6.324,6.324,0,0,0,1.672-.207A2.352,2.352,0,0,0,11.954,11.777ZM6.4,11.323v.709H5.558v-.71a1.158,1.158,0,0,1-1.031-1.108h.732c.036.3.329.5.754.5.39,0,.668-.2.668-.486,0-.242-.179-.382-.622-.481l-.468-.106c-.655-.151-.978-.5-.978-1.084a1.134,1.134,0,0,1,.945-1.137V6.709H6.4v.713a1.153,1.153,0,0,1,.966,1.093H6.655a.6.6,0,0,0-.663-.5c-.363,0-.626.185-.626.474,0,.233.171.368.593.463l.431.1c.718.16,1.035.489,1.035,1.078A1.159,1.159,0,0,1,6.4,11.32Z",
  transform: "translate(0 -0.82)",
  fill: "#7ec884"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M4.3,3.182a.449.449,0,0,0,.248.076H8.787a.424.424,0,0,0,.349-.147,10.819,10.819,0,0,0,.768-.9,3.18,3.18,0,0,0,.414-.824A.621.621,0,0,0,9.783.54,2.113,2.113,0,0,0,8.623.721c-.518.205-1.026.44-1.535.661a.923.923,0,0,1-.8,0C5.72,1.126,5.129.887,4.542.65A1.67,1.67,0,0,0,3.752.5a.72.72,0,0,0-.7,1.006A3.316,3.316,0,0,0,4.3,3.182Z",
  transform: "translate(-0.24 -0.5)",
  fill: "#7ec884",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_118",
  "data-name": "Rectangle 118",
  width: 14,
  height: 14,
  transform: "translate(1067.384 435.384)",
  fill: "none"
})));

var SvgScholarship = function SvgScholarship(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScholarship, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scholarship.8e2b74e3.svg";
export { ForwardRef as ReactComponent };